<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          <CIcon name="cil-mobile" />
          <h5 class="d-inline ml-2">User Devices</h5>
        </CCardHeader>

        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "UserDevices",
  components: {
    BackendTable,
  },
};
</script>
